import React from "react";
import { AlertTriangle, Phone, CheckCircle, XCircle, Flame, Calendar } from "lucide-react";
import { formatDate } from "../../utils/dateFormat";

/**
 * BBQPendingPaymentsPanel - Displays pending BBQ bookings awaiting payment verification
 */
const BBQPendingPaymentsPanel = ({ 
  pendingBookings, 
  onVerifyPayment, 
  onCancelBooking
}) => {
  const getPitLabel = (pit) => {
    if (pit === 'both') return 'Both Pits';
    return `Pit ${pit?.slice(-1)}`;
  };

  const getSlotTime = (slot) => {
    return slot === 'afternoon' ? '1PM - 5PM' : '6PM - 10PM';
  };

  return (
    <div className="brutal-card">
      <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
        <AlertTriangle className="text-orange-500" /> Pending BBQ Payments
      </h3>
      
      {pendingBookings.length === 0 ? (
        <p className="text-gray-500 text-center py-8">No pending BBQ payments</p>
      ) : (
        <div className="space-y-4">
          {pendingBookings.map(booking => (
            <div key={booking.booking_id} className="border-2 border-orange-300 bg-orange-50 p-4 rounded">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="font-mono font-bold text-orange-600 notranslate" translate="no">
                      {booking.booking_code}
                    </span>
                    <span className="px-2 py-0.5 bg-amber-200 text-amber-800 text-xs font-bold rounded">
                      PENDING
                    </span>
                  </div>
                  <p className="font-bold notranslate" translate="no">{booking.name}</p>
                  <p className="text-sm text-gray-600 notranslate" translate="no">{booking.block_unit}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <Calendar size={14} className="text-gray-400" />
                    <span className="text-sm font-mono">{formatDate(booking.date)} • {getSlotTime(booking.slot_type)}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Flame size={14} className="text-orange-500" />
                    <span className="text-sm text-orange-700">{getPitLabel(booking.pit_selection)} • ${booking.price}</span>
                  </div>
                </div>
                
                <div className="flex flex-col gap-2">
                  <a 
                    href={`tel:${booking.mobile}`}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white font-bold text-sm border-2 border-black hover:bg-blue-600"
                  >
                    <Phone size={16} /> 
                    <span className="notranslate" translate="no">{booking.mobile}</span>
                  </a>
                  <button
                    onClick={() => onVerifyPayment(booking.booking_id)}
                    className="flex items-center justify-center gap-2 px-4 py-2 bg-green-500 text-white font-bold text-sm border-2 border-black hover:bg-green-600"
                  >
                    <CheckCircle size={16} /> VERIFY PAYMENT
                  </button>
                  <button
                    onClick={() => onCancelBooking(booking.booking_id, booking.booking_code)}
                    className="flex items-center justify-center gap-2 px-4 py-2 bg-red-500 text-white font-bold text-sm border-2 border-black hover:bg-red-600"
                  >
                    <XCircle size={16} /> CANCEL
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BBQPendingPaymentsPanel;
